"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPutAnnotations3Response = exports.createGetAnnotations2Response = void 0;

var _lodash = require("lodash");

var _layer = require("./layer");

var _utils = require("../../../utils");

var createGetAnnotations2Response = genericAnnotationsResponse('GetAnnotations2');
exports.createGetAnnotations2Response = createGetAnnotations2Response;
var createPutAnnotations3Response = genericAnnotationsResponse('PutAnnotations3');
exports.createPutAnnotations3Response = createPutAnnotations3Response;

function genericAnnotationsResponse(method) {
  return function (raw) {
    return (0, _utils.parseModel)(raw, {
      result: {
        path: "".concat(method, "Result[0]"),
        model: _utils.genericAsResultHeader
      },
      response: function response(raw) {
        raw = (0, _lodash.get)(raw, 'AnnotationsNode[0].Annotations[0].Annotation');

        if (!raw) {
          return;
        }

        return raw.map(function (rawAnnotation) {
          return (0, _utils.parseModel)(rawAnnotation, _layer.annotation);
        });
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/annotations/response-parsers/annotations-responses.js
// module id = 232
// module chunks = 0